import { useImagingContext } from 'domains/viewer/ViewportDre/modules/imaging/ImagingContext';
import {
  BREAST_FOCI,
  DEFAULT_LABEL_ALIGNMENT,
  RIGHT_LABEL_ALIGNMENT,
} from 'domains/viewer/ViewportDre/constants';
import { useSeries } from 'domains/viewer/ViewportDre/modules/state';
import { classificationsIncludeFoci } from 'domains/viewer/ViewportDre/utils/classifications';

// @ts-expect-error [EN-10263] - TS7006 - Parameter 'imagingProvider' implicitly has an 'any' type.
const mammoProvider = (imagingProvider) => {
  return (
    imagingProvider &&
    !imagingProvider.isMultiAxesListOfFrames() &&
    imagingProvider.classificationsIncludeFoci(BREAST_FOCI)
  );
};

export const useClassificationBasedMammoFeatures = () => {
  const { imagingProvider } = useImagingContext();
  return mammoProvider(imagingProvider);
};

// this is necessary for situations where we are outside of the imaging context but can
// find the right provider
// @ts-expect-error [EN-10263] - TS7006 - Parameter 'provider' implicitly has an 'any' type.
export const useCheckClassificationBasedMammoFeatures = (provider) => {
  return mammoProvider(provider);
};

export const useShouldAlignChestWallWithSideOfViewport = () => {
  const { imagingProvider } = useImagingContext();
  // Read classifications from the reactively-hydrated series rather than the provider's snapshot.
  // The provider captures `this.classifications` once at construction from `stack.frames[0].series`,
  // which is empty when that stack is not yet hydrated (a load-dependent race). `currentSeriesAtomFamily`
  // resolves the series by the viewport config's series smid and updates when study data arrives, so the
  // mammo check re-evaluates and the chest-wall alignment recomputes once classifications land (VX-4529).
  const series = useSeries();
  const mammoFeatureCheck =
    imagingProvider != null &&
    !imagingProvider.isMultiAxesListOfFrames() &&
    classificationsIncludeFoci(series?.classifications, BREAST_FOCI);
  const orientationCheck = Boolean(
    imagingProvider?.activeSliceRowDirectionIs('anterior') ||
      imagingProvider?.activeSliceRowDirectionIs('posterior')
  );

  return mammoFeatureCheck && orientationCheck;
};

// @ts-expect-error [EN-10263] - TS7006 - Parameter 'provider' implicitly has an 'any' type.
export const useClassificationBasedLabelStyles = (provider) => {
  const mammoFeatureCheck = useCheckClassificationBasedMammoFeatures(provider);
  const orientationCheck = provider?.activeSliceRowDirectionIs('anterior');

  return mammoFeatureCheck && orientationCheck ? RIGHT_LABEL_ALIGNMENT : DEFAULT_LABEL_ALIGNMENT;
};
